const useGetLocale = (fallbackLocale: string = "en-US"): string => {
  if (typeof navigator === "undefined") {
    return fallbackLocale;
  }

  const browserLocale = navigator.language;
  if (browserLocale) {
    try {
      const cleanLocale = browserLocale.split("@")[0];
      return Intl.getCanonicalLocales(cleanLocale)[0];
    } catch (error) {
      console.warn(`Invalid locale: "${browserLocale}"`);
    }
  }

  return fallbackLocale;
};

export default useGetLocale;
